import React from 'react'
import styled from 'styled-components'
import Typography from '@mui/material/Typography'

import { ActionCardProps } from 'types/TextAnalysis'

const Wrapper = styled(Typography)({
  display: 'block',
})

const CardMeta = React.memo(function CardMeta({ cardMeta }: ActionCardProps) {
  if (!cardMeta) return <></>
  return <Wrapper variant="caption">{cardMeta}</Wrapper>
})

export { CardMeta }
